<template>
  <div class="index-cont" id="bar">
    <!-- <div class="links ">
    <el-button class="link-btn" v-for="(item,index) in links" :key="index" @click="navClick(item)" :type="item.type">{{item.name}}</el-button>
  </div> -->
  </div>
</template>

<script>
let elementResizeDetectorMaker = require("element-resize-detector");
import CardMini from "@/components/CardMini";

export default {
  name: "home",
  components: {
    CardMini,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  methods: {},
  computed: {
    links() {
      const types = ["", "primary", "success", "info", "warning", "danger"];
      const randomItem = (items) => items[(Math.random() * items.length) | 0];
      return this.$init.menu.filter((e) => {
        if (e.parentId != 0 && e.url) {
          e.type = randomItem(types);
          return e;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// PC端
.index-cont {
  background-color: #f5f5f5;
  box-sizing: border-box;
  min-height: 100%;
  padding: 5px;
  min-width: 300px;
}
.chart-box {
  background-color: #fff;
  margin: 5px;
  min-height: 400px;
  box-sizing: border-box;
  animation: zoomIn;
  animation-duration: 0.6s;
  text-align: center;
  padding: 5px;
  z-index: 1;
}
.chart-in {
  height: 350px;
}
.links {
  margin: 5px;
  background-color: #fff;
  box-sizing: border-box;
  // height: 300px;
  animation: zoomIn;
  animation-duration: 0.6s;
  padding: 10px;
  .link-btn {
    margin: 3px;
    animation: zoomIn;
    animation-duration: 1s;
  }
}

.a-out {
  background-color: #fff;
  margin: 5px;
  padding: 20px;
}
.a-cont {
  text-align: center;
}
.a-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.b-cont {
  padding-top: 10px;
  .title {
    font-size: 14px;
    line-height: 21px;
    color: #9e9e9e;
  }
  .num {
    font-size: 21px;
    line-height: 31px;
  }
}
.chart-box-name {
  font-size: 14px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.87);
}
table {
  border: none;
  border-color: #ebeef5;
  width: 100%;
  margin-top: 20px;
  td {
    padding: 10px;
    color: #606266;
  }
  th {
    padding: 10px;
    font-weight: 700;
    color: #8ea8bf;
  }
}

.writing {
  box-sizing: border-box;
  // width: 600px;
  font-size: 12px;
  li {
    float: left;
    background-color: #fff;
    position: relative;
    z-index: 10;
    overflow: hidden;
    width: 50%;
    a {
      padding: 1.3em;
      display: block;
      width: 100%;
      height: 100px;
      padding: 20px;
      box-sizing: border-box;
      &:hover {
        h3::after {
          transform: scaleY(18) scaleX(12);
          transition: all 0.15s ease-in;
        }
      }
      h3 {
        font-size: 1.4em !important;
        line-height: 1.6em;
        line-height: 1.6em;
        font-weight: 600;
        position: relative;
        margin-bottom: 0.3em;
        position: relative;
        box-sizing: border-box;
        display: inline-block;
        &::after {
          width: calc(100% + 30px);
          display: block;
          content: "";
          background: rgba(134, 107, 147, 50%);
          margin-top: -0.7em;
          margin-left: -10px;
          height: 0.8em;
          position: absolute;
          z-index: -1;
          transition: all 0.3s ease-out;
        }
      }
      p {
        font-size: 1.2em;
      }
    }
  }
}
</style>
